var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H5C2 0 0 1.5 0 5V12C0 15.5 2 17 5 17H15C18 17 20 15.5 20 12V5C20 1.5 18 0 15 0ZM15.47 6.09L12.34 8.59C11.68 9.12 10.84 9.38 10 9.38C9.16 9.38 8.31 9.12 7.66 8.59L4.53 6.09C4.21 5.83 4.16 5.35 4.41 5.03C4.67 4.71 5.14 4.65 5.46 4.91L8.59 7.41C9.35 8.02 10.64 8.02 11.4 7.41L14.53 4.91C14.85 4.65 15.33 4.7 15.58 5.03C15.84 5.35 15.79 5.83 15.47 6.09Z",
    fill: "#FEC200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0219badf44e848d8859797a68ee68579.svg";
export { ForwardRef as ReactComponent };